import React from 'react';
export function CTASection() {
  return <section className="py-16 bg-gray-900 text-white" data-id="element-114">
      <div className="container mx-auto px-4" data-id="element-115">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-116">
          <div className="md:w-1/2" data-id="element-117">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7n1HjkJV7hZe3cdfgoPvA/1000001242.png" alt="247Alpha supplement bottle" className="rounded-lg shadow-xl w-full h-auto max-w-md mx-auto" data-id="element-118" />
          </div>
          <div className="md:w-1/2 text-center md:text-left" data-id="element-119">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif" data-id="element-120">
              THE CHOICE IS YOURS
            </h2>
            <div className="mb-12" data-id="element-121">
              <p className="mb-6" data-id="element-122">You have two paths in front of you.</p>
              <div className="mb-8" data-id="element-123">
                <h3 className="text-xl font-bold mb-3 text-red-500" data-id="element-124">
                  Path One:
                </h3>
                <p data-id="element-125">
                  Do nothing. Keep accepting "normal" testosterone levels for
                  your age. Watch your energy, strength, and drive continue to
                  fade. Become increasingly invisible and irrelevant. Let Big
                  Pharma win.
                </p>
              </div>
              <div data-id="element-126">
                <h3 className="text-xl font-bold mb-3 text-green-500" data-id="element-127">
                  Path Two:
                </h3>
                <p data-id="element-128">
                  Take control. Reclaim what's rightfully yours. Use the ancient
                  wisdom they tried to bury to restore your masculine vitality.
                  Become the man your family needs and your ancestors would be
                  proud of.
                </p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg" data-id="element-129">
              <div className="text-blue-400 font-bold mb-3 text-xl" data-id="element-130">
                FOR A LIMITED TIME - SAVE 50%
              </div>
              <a href="https://the247alpha.com/products/alpha-energy?variant=52325407719751" className="inline-block bg-blue-800 hover:bg-blue-900 text-white text-xl px-10 py-4 rounded-md font-bold transition duration-300 transform hover:scale-105 w-full md:w-auto" data-id="element-131">
                ORDER 247ALPHA NOW - ONLY $60
              </a>
              <p className="mt-4 text-sm text-gray-400" data-id="element-132">
                Warning: Due to high demand and limited supply, we can only
                guarantee availability for the next 4 hours. Order now to avoid
                disappointment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}